import script from "./Error503.vue?vue&type=script&setup=true&lang=ts"
export * from "./Error503.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__